import { useEffect, useState } from "react";

function RosterListButton({
  issuedList,
  currentScheduleDate,
  setCurrentScheduleDate,
}: {
  issuedList: { year: number; month: number; schedule_id: string }[];
  currentScheduleDate: { year: number; month: number; schedule_id: string };
  setCurrentScheduleDate: (value: {
    year: number;
    month: number;
    schedule_id: string;
  }) => void;
}) {
  const [isOpendChangeDateList, setIsOpendChangeDateList] =
    useState<boolean>(false);

  const [currentIndex, setCurrentIndex] = useState<number>(0);

  function changeDatePrev(int: number) {
    const changeIndex = currentIndex - int;
    setCurrentScheduleDate(issuedList[changeIndex]);
  }

  function init_findDateIndex() {
    const dateIndex = issuedList.findIndex(
      (item) =>
        Number(item.year) === Number(currentScheduleDate.year) &&
        Number(item.month) === Number(currentScheduleDate.month)
    );
    return dateIndex > 0 ? dateIndex : 0;
  }

  useEffect(() => {
    setCurrentIndex(init_findDateIndex());
  }, [currentScheduleDate]);

  if (!currentScheduleDate) return;
  return (
    <div className="view_dateButtonWrap rounded-lg! h-[45px]!">
      <button
        type="button"
        className="changeDate changeDate--prev"
        disabled={currentIndex === issuedList.length - 1}
        onClick={() => {
          changeDatePrev(-1);
        }}
      ></button>
      <button
        type="button"
        className="dateTextButton"
        onClick={() => {
          setIsOpendChangeDateList((prev) => !prev);
        }}
      >
        {currentScheduleDate.year}년 {currentScheduleDate.month}월
      </button>
      <button
        type="button"
        className="changeDate changeDate--next"
        disabled={currentIndex === 0}
        onClick={() => {
          changeDatePrev(1);
        }}
      ></button>

      {isOpendChangeDateList && (
        <div className="view_date_list">
          {issuedList.map((item, index) => {
            // const current = currentSchedule.year === item.year && currentSchedule.month === item.month;
            const current = currentIndex === index;

            return (
              <button
                type="button"
                key={`${index}-${currentScheduleDate.year}-${currentScheduleDate.month}`}
                className={`view_date_selectBox ${current ? "current" : ""}`}
                onClick={() => {
                  setCurrentIndex(index);
                  setCurrentScheduleDate({
                    year: item.year,
                    month: item.month,
                    schedule_id: item.schedule_id,
                  });
                  setIsOpendChangeDateList(false);
                }}
              >
                {item.year}년 {item.month}월
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default RosterListButton;
